<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <div id="payment-page" class="qi-content">
        <header>
          <h1>Seleção da Forma de Pagamento</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBox></SelectedCourseBox>
          <SelectedOfferBox></SelectedOfferBox>
        </vs-row>

        <h3>
          Selecione Parcelamento/Vencimento da Primeira Parcela
          <span v-if="level === 'S'">- Supervisão</span>
          <span v-if="level === 'C'">- Coordenação</span>
        </h3>
        <vs-row>
          <vs-alert
            title="Erro ao buscar o parcelamento"
            class="margin"
            color="danger"
            style="margin-bottom: 15px"
            v-if="error3"
          >
            {{ error3 }}
          </vs-alert>

          <vs-col
            v-for="(installment, i) in installmentsOptions"
            :key="installment.IDPARCELAMENTO"
            vs-lg="4"
            vs-sm="6"
            vs-xs="12"
          >
            <div @click="selectInstallment(installment)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected:
                    installment.IDPARCELAMENTO ===
                    installmentSelected.IDPARCELAMENTO,
                }"
              >
                <div class="no-flex" slot="header">
                  <h4 class="text-center">Opção {{ i + 1 }}</h4>
                </div>
                <div class="spacing-children">
                  <p>
                    Quant. máx. de parcelas:
                    {{ installment.NUMERODEPARCELAS }}
                  </p>

                  <div>
                    <label :for="'select-' + installment.IDPARCELAMENTO">
                      Data de Vencimento <br />
                      <p style="font-size: 0.75em">(1ª parcela)</p>
                    </label>
                    <vs-select
                      style="margin-top: -17.5px"
                      :id="'select-' + installment.IDPARCELAMENTO"
                      v-model="installment.dueDate"
                      v-if="installment.dueDateOptions.length"
                      :danger="checkDueDate(installment)"
                      danger-text="Selecione o vencimento da 1ª parcela"
                      v-on:change="updateSecondDueDateOptions()"
                    >
                      <vs-select-item
                        v-for="(date, index) in installment.dueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>
                    <p v-else>Erro ao carregar opções de vencimento</p>
                  </div>
                </div>
                <div>
                  <label
                    :for="'num-of-installments-' + installment.IDPARCELAMENTO"
                  >
                    Número de Parcelas:
                  </label>
                  <vs-select
                    :id="'num-of-installments-' + installment.IDPARCELAMENTO"
                    v-model="installment.numberOfInstallments"
                    :disabled="!installmentSelected"
                    v-on:change="updateScholarShips(installment)"
                  >
                    <vs-select-item
                      v-for="(_, i) in numberOfInstallmentsPossible"
                      :key="i"
                      :value="i + 1"
                      :text="i + 1"
                    />
                  </vs-select>
                </div>

                <div
                  class="spacing-children"
                  v-if="
                    installment.ULTIMOVENCVALIDO2 != '0' &&
                    installment.numberOfInstallments > 1
                  "
                >
                  <div v-if="installment.showSecondDate">
                    <label :for="'select2-' + installment.IDPARCELAMENTO">
                      Data de Vencimento <br />
                      <p style="font-size: 0.75em">
                        (2ª parcela) <br />
                        * Referência ao início do curso
                      </p>
                    </label>
                    <vs-select
                      style="margin-top: -17.5px"
                      :id="'select2-' + installment.IDPARCELAMENTO"
                      v-model="installment.secondDueDate"
                      :danger="checkSecondDueDate(installment)"
                      danger-text="Selecione o vencimento da 2ª parcela"
                    >
                      <vs-select-item
                        v-for="(
                          date, index
                        ) in installment.secondDueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>
                  </div>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>

        <div>
          <h3>Bolsas Disponíveis (opcional)</h3>
        </div>
        <p v-if="!scholarchipOptions">
          Sem bolsas disponíveis. Entre em contato com o Financeiro.
        </p>
        <vs-row style="margin-top: 10px" v-else>
          <vs-col
            vs-w="3"
            vs-sm="12"
            v-if="
              scholarchipOptionsCritical &&
              scholarchipOptionsCritical[0].PERCBOLSATURMACRITICA != '0.00'
            "
          >
            <vs-col
              v-for="scholarchipCritical in scholarchipOptionsCritical"
              :key="scholarchipCritical.IDBOLSA"
              vs-w="12"
            >
              <div @click="selectScholarshipCriticalClass(scholarchipCritical)">
                <vs-card
                  class="exception-card"
                  :class="{
                    selected:
                      scholarchipCritical === scholarshipSelectedCriticalClass,
                  }"
                >
                  <div class="no-flex" slot="header">
                    <h4 style="color: red" class="text-center">
                      BOLSA TURMA CRÍTICA
                    </h4>
                    <div style="display: flex; justify-content: center">
                      <span
                        style="margin-top: 6.75px; font-size: 13.5px"
                        class="material-icons"
                      >
                        info
                      </span>
                      <p
                        class="text-center"
                        style="font-size: 1em; margin-top: 1.5px"
                      >
                        Máximo:
                        <b
                          >{{
                            parseFloat(
                              scholarchipCritical.PERCBOLSATURMACRITICA
                            )
                          }}%</b
                        >
                      </p>
                    </div>
                  </div>
                  <div class="spacing-children">
                    <vs-input
                      :id="'scholarship-' + scholarchipCritical.IDBOLSA"
                      v-model="scholarchipCritical.scholarshipPercentCritical"
                      icon-after
                      icon="shopping_cart"
                      :danger="scholarchipCritical.isDiscountPercentOfflimits"
                      :success="scholarchipCritical.percentAllowed"
                      type="number"
                      :max="scholarchipCritical.PERCMAX"
                      :min="0"
                      v-on:keyup="checkScholarshipValue"
                      v-on:blur="checkScholarshipValue"
                    />
                  </div>
                </vs-card>
              </div>
            </vs-col>
          </vs-col>
          <vs-col
            vs-w="3"
            vs-sm="12"
            v-if="
              scholarchipOptionsExternal &&
              scholarchipOptionsExternal[0].PERCMAX != '0.00'
            "
          >
            <vs-col
              v-for="scholarchipExternal in scholarchipOptionsExternal"
              :key="scholarchipExternal.IDBOLSA"
              vs-w="12"
            >
              <div @click="selectScholarshipExternal(scholarchipExternal)">
                <vs-card
                  class="choosable-card"
                  :class="{
                    selected:
                      scholarchipExternal === scholarshipSelectedExternal,
                  }"
                >
                  <div class="no-flex" slot="header">
                    <h4 class="text-center">
                      {{ scholarchipExternal.DESCRICAO }}
                    </h4>
                    <div style="display: flex; justify-content: center">
                      <span
                        style="margin-top: 6.75px; font-size: 13.5px"
                        class="material-icons"
                      >
                        info
                      </span>
                      <p
                        class="text-center"
                        style="font-size: 1em; margin-top: 1.5px"
                      >
                        Máximo:
                        <b>{{ parseFloat(scholarchipExternal.PERCMAX) }}%</b>
                      </p>
                    </div>
                  </div>
                  <div class="spacing-children">
                    <vs-input
                      :id="'scholarship-' + scholarchipExternal.IDBOLSA"
                      v-model="scholarchipExternal.scholarshipPercentExternal"
                      icon-after
                      icon="shopping_cart"
                      :danger="scholarchipExternal.isDiscountPercentOfflimits"
                      :success="scholarchipExternal.percentAllowed"
                      type="number"
                      :max="scholarchipExternal.PERCMAX"
                      :min="0"
                      v-on:keyup="checkScholarshipValue"
                      v-on:blur="checkScholarshipValue"
                    />
                  </div>
                </vs-card>
              </div>
            </vs-col>
          </vs-col>
          <vs-col vs-w="3" vs-sm="12">
            <vs-col
              v-for="scholarchip in scholarchipOptions"
              :key="scholarchip.IDBOLSA"
              vs-xs="12"
            >
              <div @click="selectScholarship(scholarchip)">
                <vs-card
                  class="choosable-card"
                  :class="{ selected: scholarchip === scholarshipSelected }"
                >
                  <div class="no-flex" slot="header">
                    <h4 class="text-center">{{ scholarchip.DESCRICAO }}</h4>
                    <div style="display: flex; justify-content: center">
                      <span
                        style="margin-top: 6.75px; font-size: 13.5px"
                        class="material-icons"
                      >
                        info
                      </span>
                      <p
                        class="text-center"
                        style="font-size: 1em; margin-top: 1.5px"
                      >
                        Máximo: <b>{{ parseFloat(scholarchip.PERCMAX) }}%</b>
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="scholarchip.ALTERARVALOR == 'S'"
                    class="spacing-children"
                  >
                    <vs-input
                      :id="'scholarship-' + scholarchip.IDBOLSA"
                      v-model="scholarchip.scholarshipPercent"
                      icon-after
                      icon="shopping_cart"
                      type="number"
                      :danger="scholarchip.isDiscountPercentOfflimits"
                      :success="scholarchip.percentAllowed"
                      :max="scholarchip.PERCMAX"
                      :min="0"
                      v-on:keyup="checkScholarshipValue"
                      v-on:blur="checkScholarshipValue"
                    />
                  </div>
                  <div v-else style="display: flex; justify-content: center">
                    <span
                      style="margin-top: 6.75px; font-size: 13.5px"
                      class="material-icons"
                    >
                      info
                    </span>
                    <p
                      class="text-center"
                      style="font-size: 1em; margin-top: 1.5px"
                    >
                      Percentual Fixo:
                      <b>{{ parseFloat(scholarchip.PERCMAX) }}%</b>
                    </p>
                  </div>
                  <p
                    class="text-center"
                    style="
                      margin-top: 15px;
                      margin-bottom: 5px;
                      font-size: 1em;
                      font-weight: bold;
                    "
                    v-if="scholarchip.QTDDISPONIVEL != '9999'"
                  >
                    Quantidade Disponível: {{ scholarchip.QTDDISPONIVEL }}
                  </p>
                </vs-card>
              </div>
            </vs-col>
          </vs-col>
        </vs-row>

        <div
          v-if="
            scholarshipSelected &&
            this.scholarshipSelected.scholarshipPercent != '' &&
            this.scholarshipSelected.scholarshipPercent != '0' &&
            !scholarshipSelectedCriticalClass &&
            !scholarshipSelectedExternal
          "
        >
          <div>
            <h3>Bolsas Exceção (opcional)</h3>
          </div>
          <p v-if="!scholarchipOptionsException">
            Sem bolsas disponíveis. Entre em contato com o Financeiro.
          </p>
          <vs-row style="margin-top: 10px" v-else>
            <vs-col
              v-for="scholarchip in scholarchipOptionsException"
              :key="scholarchip.IDBOLSA"
              vs-w="3"
              vs-sm="12"
            >
              <div @click="selectScholarshipException(scholarchip)">
                <vs-card
                  class="choosable-card"
                  :class="{
                    selected: scholarchip === scholarshipSelectedException,
                  }"
                >
                  <div class="no-flex" slot="header">
                    <h4 class="text-center">{{ scholarchip.DESCRICAO }}</h4>
                    <div style="display: flex; justify-content: center">
                      <span
                        style="margin-top: 6.75px; font-size: 13.5px"
                        class="material-icons"
                      >
                        info
                      </span>
                      <p
                        class="text-center"
                        style="font-size: 1em; margin-top: 1.5px"
                      >
                        Percentual Fixo:
                        <b>{{ parseFloat(scholarchip.PMAX) }}%</b>
                      </p>
                    </div>
                    <p
                      class="text-center"
                      style="
                        margin-top: 15px;
                        margin-bottom: 5px;
                        font-size: 1em;
                        font-weight: bold;
                      "
                      v-if="scholarchip.QTDDISPONIVEL != '9999'"
                    >
                      Quantidade Disponível: {{ scholarchip.QTDDISPONIVEL }}
                    </p>
                  </div>
                </vs-card>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-row style="margin-top: -5px !important">
          <vs-col>
            <vs-button
              icon="highlight_off"
              :disabled="
                !scholarshipSelected &&
                !scholarshipSelectedException &&
                !scholarshipSelectedCriticalClass &&
                !scholarshipSelectedExternal
              "
              @click="clearScholarShip()"
              type="filled"
            >
              Remover Bolsa Selecionada
            </vs-button>
          </vs-col>
        </vs-row>
        <h3 style="margin-top: 10px">Selecione Forma de Pagamento</h3>
        <vs-row>
          <vs-col
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
            v-for="(payment, index) in paymentOptions"
            v-bind:key="index"
            :style="
              payment.DESCRICAO != 'Crédito Recorrente' &&
              payment.DESCRICAO != 'CRÉDITO RECORRENTE' &&
              payment.DESCRICAO != 'Recorrente' &&
              payment.DESCRICAO != 'RECORRENTE' &&
              ((installmentSelected.numberOfInstallments != 1 &&
                payment.AVISTA === 'S') ||
                (installmentSelected.numberOfInstallments == 1 &&
                  payment.AVISTA === 'N'))
                ? 'display: none;'
                : ''
            "
            :value="payment.IDFORMAPGTO"
          >
            <div @click="selectPayment(payment)">
              <vs-card
                class="choosable-card"
                :class="{ selected: payment === paymentSelected }"
              >
                <div slot="header">
                  <h3 class="text-center">
                    {{ payment.DESCRICAO.toUpperCase() }}
                  </h3>
                </div>
                <div class="spacing-children">
                  <p>
                    Valor Bruto da Parcela: R${{ getInstallmentValue(payment) }}
                  </p>
                  <p
                    v-if="
                      scholarshipSelected ||
                      scholarshipSelectedException ||
                      scholarshipSelectedCriticalClass ||
                      scholarshipSelectedExternal
                    "
                  >
                    Percentual de Bolsa Aplicado:
                    {{
                      (scholarshipSelected &&
                      scholarshipSelected.scholarshipPercent
                        ? parseFloat(scholarshipSelected.scholarshipPercent)
                        : 0) +
                      (scholarshipSelectedExternal &&
                      scholarshipSelectedExternal.scholarshipPercentExternal
                        ? parseFloat(
                            scholarshipSelectedExternal.scholarshipPercentExternal
                          )
                        : 0) +
                      (scholarshipSelectedCriticalClass &&
                      scholarshipSelectedCriticalClass.scholarshipPercentCritical
                        ? parseFloat(
                            scholarshipSelectedCriticalClass.scholarshipPercentCritical
                          )
                        : 0) +
                      (scholarshipSelectedException
                        ? parseFloat(scholarshipSelectedException.PMAX)
                        : 0)
                    }}% (R${{ getScholarshipValue(payment) }})
                  </p>
                  <p>
                    Valor Líquido<b
                      v-if="
                        scholarshipSelected ||
                        scholarshipSelectedException ||
                        scholarshipSelectedCriticalClass ||
                        scholarshipSelectedExternal
                      "
                    >
                      com Bolsa</b
                    >: R${{ getInstallmentLiquidValue(payment) }}
                  </p>
                  <p>
                    Desconto Adimplência:
                    {{ Number(payment.PERCDESC) }}% (R${{
                      getPaymentDiscount(payment)
                    }})
                  </p>
                  <p>
                    Valor Final:
                    {{ installmentSelected.numberOfInstallments }}
                    x R${{ getTotalValue(payment) }} (R${{
                      Number(
                        installmentSelected.numberOfInstallments *
                          getTotalValue(payment)
                      ).toFixed(2)
                    }})
                  </p>
                  <p v-if="scholarshipAttData && payment.AVISTA != 'S'">
                    <strong> Desconto adicional</strong>, parcela
                    {{ scholarshipAttData.PARCELAINI }} a
                    {{ scholarshipAttData.PARCELAFIM }} de
                    {{ scholarshipAttData.PERCENTUAL }}%
                  </p>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-alert
          title="Erro ao buscar as formas de pagamento do curso"
          class="margin"
          color="danger"
          v-if="error2"
        >
          {{ error2 }}
        </vs-alert>

        <vs-row>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level != 'S'">
            <vs-button
              icon="refresh"
              style="width: 100%"
              @click="updateInstallmentOptions('S')"
              type="filled"
              color="danger"
            >
              Carregar Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level == 'S'">
            <vs-button
              icon="highlight_off"
              style="width: 100%"
              @click="updateInstallmentOptions('V')"
              type="filled"
            >
              Remover Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level != 'C'">
            <vs-button
              icon="refresh"
              style="width: 100%"
              :disabled="!edit && !scholarshipCoordinator"
              @click="updateInstallmentOptions('C')"
              type="filled"
              color="danger"
            >
              Carregar Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level == 'C'">
            <vs-button
              icon="highlight_off"
              style="width: 100%"
              @click="updateInstallmentOptions('V')"
              type="filled"
            >
              Remover Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              :disabled="!paymentSelected.IDFORMAPGTO"
              @click="goFoward()"
              type="filled"
              color="#139B0E"
            >
              Confirmar e Avançar
            </vs-button>
          </vs-col>
          <vs-col vs-w="12" vs-xs="12" v-if="edit && !isStudent">
            <vs-button
              icon="check_circle"
              style="width: 100%"
              @click="scapePayment()"
              type="filled"
              color="#139B0E"
            >
              Continuar sem Alterar
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
    <ConsultValidationMat />
  </div>
</template>
<script>
import SelectedCourseBox from "../components/SelectedCourseBox.vue";
import SelectedOfferBox from "../components/SelectedOfferBox.vue";
import ConsultValidationMat from "../components/ConsultValidationMat.vue"
import {
  getLoginDataFromStorage,
  getStepsInformation,
  updateStepsInformation,
} from "../helpers/storage";
import FinancialService from "../services/financial";
import {
  formatDateToUSA,
  updateDiscussion,
  getDateOptions,
  getSecondDateOptions,
  formatDateToLocale,
} from "../helpers";
import moment from "moment";

export default {
  name: "Payment",
  components: {
    SelectedCourseBox,
    SelectedOfferBox,
    ConsultValidationMat
  },
  data: () => ({
    scholarshipPercent: "",
    scholarshipPercentExternal: "",
    scholarshipPercentCritical: "",
    scholarshipAttData: null,
    installmentSelected: null,
    installmentsOptions: [],
    numberOfInstallments: 1,
    paymentOptions: [],
    paymentSelected: {},
    isDiscountPercentOfflimits: false,
    percentAllowed: false,
    scholarchipOptions: null,
    scholarchipOptionsExternal: null,
    scholarchipOptionsCritical: null,
    scholarchipOptionsException: null,
    scholarshipSelected: null,
    scholarshipSelectedExternal: null,
    scholarshipSelectedCriticalClass: null,
    scholarshipSelectedException: null,
    percentWatchTimeout: 0,
    totalCourseValue: 0,
    dueDate: "",
    error: null,
    error2: null,
    error3: null,
    level: "V",
    offer: null,
    classData: null,
    infoTax: null,
    edit: false,
    preRegistration: null,
    scholarshipCoordinator: false,
    subjectId: null,
    reEnrollment: false,
    isStudent: false,
  }),
  mounted() {
    this.$vs.loading();

    const { ...user } = getLoginDataFromStorage();
    this.profiles = user.profiles;

    const profileCoordinator = this.profiles.find(
      (element) => element == "SupervisorVenda"
    );

    if (profileCoordinator) {
      this.scholarshipCoordinator = true;
    } else {
      this.scholarshipCoordinator = false;
    }

    const {
      offer,
      course,
      preRegistration,
      edit,
      classData,
      tax,
      preRegistrationSubjects,
      reEnrollment,
    } = getStepsInformation();
    const loginData = getLoginDataFromStorage();
    if (loginData.RA) {
      this.isStudent = true;
    }
    if (edit) this.subjectId = this.getFirstSubjectId(preRegistrationSubjects);
    this.reEnrollment = reEnrollment;
    this.offer = offer;
    this.classData = classData;
    this.infoTax = tax;
    this.edit = edit;
    this.preRegistration = preRegistration;
    let classificationId, qualificationId;
    if (edit) classificationId = preRegistration.IDCLASSIFICACAO;
    else if (reEnrollment) classificationId = offer.IDCLASSIFICACAO;
    else classificationId = course.IDCLASSIFICACAO;

    if (edit) qualificationId = preRegistration.IDHABILITACAOFILIAL;
    else qualificationId = offer.IDHABILITACAOFILIAL;

    if (edit)
      this.totalCourseValue = Number(
        preRegistration.VALORPARCELA * preRegistration.NUMPARCELA
      );
    else if (reEnrollment) this.totalCourseValue = Number(offer.VALOR);
    else this.totalCourseValue = Number(course.VALOR);

    this.updateInstallmentOptions(this.level);

    new FinancialService()
      .getPaymentOptions(classificationId, qualificationId, "P")
      .then(({ data }) => {
        this.paymentOptions = Array.isArray(data) ? data : [data];
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error2 = response.data.error;
        }
      });
  },
  methods: {
    checkDueDate(installment) {
      if (installment == this.installmentSelected) {
        if (installment.dueDate == "") return true;
      }
    },

    checkSecondDueDate(installment) {
      if (installment == this.installmentSelected) {
        if (installment.secondDueDate == "") return true;
      }
    },

    getFirstSubjectId(subjects) {
      let find = false;
      let cont = 0;
      while (!find && cont < subjects.length) {
        if (subjects[cont].TIPO == "N" || subjects[cont].TIPO == "E")
          find = true;
        cont++;
      }
      return subjects[cont - 1].IDTURMADISC;
    },

    dataMaxima(tax) {
      const partesData = tax.split("/");
      const data = new Date(partesData[2], partesData[1] - 1, partesData[0]);

      if (data.getDate() <= 15) {
        const primeiroDiaDoProximoMes = new Date(
          data.getFullYear(),
          data.getMonth() + 1,
          1
        );
        const ultimoDiaDoMes = new Date(primeiroDiaDoProximoMes - 1);
        return (
          ultimoDiaDoMes.getDate() +
          "/" +
          (ultimoDiaDoMes.getMonth() + 1 < 10
            ? "0" + (ultimoDiaDoMes.getMonth() + 1)
            : ultimoDiaDoMes.getMonth() + 1) +
          "/" +
          ultimoDiaDoMes.getFullYear()
        );
      } else {
        const proximoMes = new Date(data.getFullYear(), data.getMonth() + 1);

        let count = 0;
        let dia = 1;
        let dataAtual = new Date(proximoMes);

        while (count < 5) {
          dataAtual.setDate(dia);
          const diaSemana = dataAtual.getDay();
          if (diaSemana !== 0) {
            count++;
          }
          dia++;
        }

        return dataAtual;
      }
    },

    dataLimite(dt) {
        return dt;
    },

    updateInstallmentOptions(level) {
      this.level = level;
      this.installmentsOptions = [];
      this.installmentSelected = null;
      this.scholarchipOptions = null;
      this.scholarchipOptionsExternal = null;
      this.scholarchipOptionsCritical = null;
      this.scholarchipOptionsException = null;
      this.scholarshipAttData = null;
      this.scholarshipSelected = null;
      this.scholarshipSelectedExternal = null;
      this.scholarshipSelectedCriticalClass = null;
      this.scholarshipSelectedException = null;
      
      const { offer, classData, course, tax, reEnrollment, reusedCpf } =
        getStepsInformation();
      let classificationId, qualificationId, subjectId, taxDueDate;

      if (this.edit) classificationId = this.preRegistration.IDCLASSIFICACAO;
      else if (reEnrollment) classificationId = offer.IDCLASSIFICACAO;
      else classificationId = course.IDCLASSIFICACAO;

      this.edit
        ? (qualificationId = this.preRegistration.IDHABILITACAOFILIAL)
        : (qualificationId = offer.IDHABILITACAOFILIAL);
      this.edit
        ? (subjectId = this.subjectId)
        : (subjectId = classData.IDTURMADISC);

      if (reusedCpf) {
        taxDueDate = formatDateToUSA(new Date());
      } else if (this.edit) {
        taxDueDate = this.preRegistration.DTVENCIMENTOTAXA;
      } else if (reEnrollment) {
        taxDueDate = formatDateToUSA(new Date());
      } else {
        taxDueDate = formatDateToUSA(tax.dueDate);
      }

      new FinancialService()
        .getInstallment(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          taxDueDate
        )
        .then(({ data }) => {
          const installmentsOptionsAux = Array.isArray(data) ? data : [data];
          this.installmentsOptions = installmentsOptionsAux.map(
            (installment) => ({
              ...installment,
              dueDateOptions: getDateOptions(
                reusedCpf
                  ? moment().startOf("day")
                  : moment(formatDateToLocale(taxDueDate), "DD/MM/YYYY").add(1, "days"),
                tax && tax.VALORTAXA == "78.99"
                  ? moment(this.dataMaxima(tax.dueDate), "DD/MM/YYYY")
                  : moment(
                      this.dataLimite(installment.ULTIMOVENCVALIDO),
                      "DD/MM/YYYY"
                    )
              ),
              dueDate: "",
              secondDueDateOptions: [],
              secondDueDate: "",
              numberOfInstallments: 1,
              showSecondDate: moment(
                installment.ULTIMOVENCVALIDO2,
                "DD/MM/YYYY"
              ).isAfter(moment(installment.ULTIMOVENCVALIDO, "DD/MM/YYYY")),
            })
          );
          this.installmentSelected = this.installmentsOptions[0];

          this.getScholarShip();
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error3 = response.data.error;
          }
          this.$vs.loading.close();
        });
    },

    selectPayment(paymentMethod) {
      this.paymentSelected = paymentMethod;
      const { tax, reEnrollment } = getStepsInformation();
      let today = new Date();
      today.setDate(today.getDate() + 5);
      today = formatDateToLocale(today);

      if (this.paymentSelected.AVISTA === "S") {
        this.installmentSelected.numberOfInstallments = 1;
        reEnrollment
          ? (this.installmentSelected.dueDate = today)
          : (this.installmentSelected.dueDate = tax.dueDate);
      }
    },

    selectInstallment(installment) {
      this.installmentSelected = installment;
      this.dueDateSecondInstallment = "";
      this.updateScholarShips();
      this.updateSecondDueDateOptions();
    },

    selectScholarship(scholarship) {
      this.scholarshipSelectedException = null;
      this.scholarshipSelected = scholarship;
      this.scholarshipSelectedExternal = null;

      if (this.scholarshipSelected.ALTERARVALOR == "N") {
        this.scholarshipSelected.scholarshipPercent =
          this.scholarshipSelected.PERCMAX;
        this.scholarshipSelected.percentAllowed = true;
      } else if (this.scholarshipSelected.scholarshipPercent) {
        if (
          parseFloat(this.scholarshipSelected.scholarshipPercent) >
          parseFloat(this.scholarshipSelected.PERCMAX)
        ) {
          this.scholarshipSelected.scholarshipPercent = parseFloat(
            this.scholarshipSelected.PERCMAX
          );
          this.scholarshipSelected.isDiscountPercentOfflimits = true;
        }
      }
    },

    selectScholarshipExternal(scholarship) {
      this.scholarshipSelectedException = null;
      this.scholarshipSelectedExternal = scholarship;
      this.scholarshipSelectedCriticalClass = null;
      this.scholarshipSelected = null;

      if (this.scholarshipSelectedExternal.scholarshipPercentExternal) {
        if (
          parseFloat(
            this.scholarshipSelectedExternal.scholarshipPercentExternal
          ) > parseFloat(this.scholarshipSelectedExternal.PERCMAX)
        ) {
          this.scholarshipSelectedExternal.scholarshipPercentExternal =
            parseFloat(this.scholarshipSelectedExternal.PERCMAX);
          this.scholarshipSelectedExternal.isDiscountPercentOfflimits = true;
        }
      }
    },

    selectScholarshipCriticalClass(scholarship) {
      this.scholarshipSelectedException = null;
      this.scholarshipSelectedCriticalClass = scholarship;
      this.scholarshipSelectedExternal = null;

      if (this.scholarshipSelectedCriticalClass.scholarshipPercentCritical) {
        if (
          parseFloat(
            this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
          ) >
          parseFloat(
            this.scholarshipSelectedCriticalClass.PERCBOLSATURMACRITICA
          )
        ) {
          this.scholarshipSelectedCriticalClass.scholarshipPercentCritical =
            parseFloat(
              this.scholarshipSelectedCriticalClass.PERCBOLSATURMACRITICA
            );
          this.scholarshipSelectedCriticalClass.isDiscountPercentOfflimits = true;
        }
      }
    },

    selectScholarshipException(scholarship) {
      this.scholarshipSelectedException = scholarship;
      this.scholarshipSelectedException.scholarshipPercent =
        this.scholarshipSelectedException.PMAX;
      this.scholarshipSelectedException.percentAllowed = true;
    },

    updateSecondDueDateOptions() {
      if (!this.installmentSelected.showSecondDate) {
        this.installmentSelected.secondDueDate = formatDateToLocale(
          moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(1, "month")
        );
      } else if (
        this.installmentSelected.ULTIMOVENCVALIDO2 != "0" &&
        this.installmentSelected.numberOfInstallments > 1
      ) {
        this.installmentSelected.secondDueDateOptions = getSecondDateOptions(
          moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(
            1,
            "month"
          ),
          moment(this.installmentSelected.ULTIMOVENCVALIDO2, "DD/MM/YYYY")
        );
        this.installmentSelected.secondDueDate =
          this.installmentSelected.secondDueDateOptions[0];
      } else {
        if (this.installmentSelected.dueDate != "") {
          this.installmentSelected.secondDueDate = formatDateToLocale(
            moment(this.installmentSelected.dueDate, "DD/MM/YYYY").add(
              1,
              "month"
            )
          );
        }
      }
    },

    getScholarshipByAttendance() {
      //this.$vs.loading();
      this.scholarshipAttData = null;
      const { codAtendimento, codLocal, course, offer, reEnrollment } =
        getStepsInformation();
      let classificationId, qualificationId;

      if (this.edit) classificationId = this.preRegistration.IDCLASSIFICACAO;
      else if (reEnrollment) classificationId = offer.IDCLASSIFICACAO;
      else classificationId = course.IDCLASSIFICACAO;

      if (this.edit) qualificationId = this.preRegistration.IDHABILITACAOFILIAL;
      else if (reEnrollment) qualificationId = course.IDHABILITACAOFILIAL;
      else qualificationId = offer.IDHABILITACAOFILIAL;

      new FinancialService()
        .getScholarshipsByAttendance(
          classificationId,
          qualificationId,
          this.installmentSelected.numberOfInstallments,
          codAtendimento,
          codLocal
        )
        .then(({ data }) => {
          if (data) this.scholarshipAttData = data;
          else this.scholarshipAttData = null;
        });
    },

    getScholarShip() {
      this.scholarchipOptions = null;
      this.scholarchipOptionsExternal = null;
      this.scholarchipOptionsCritical = null;
      this.scholarchipOptionsException = null;
      this.scholarshipSelected = null;
      this.scholarshipSelectedExternal = null;
      this.scholarshipSelectedCriticalClass = null;
      this.scholarshipSelectedException = null;
      const { course, offer, classData, reEnrollment } = getStepsInformation();
      let classificationId, qualificationId, subjectId;
      if (this.edit) classificationId = this.preRegistration.IDCLASSIFICACAO;
      else if (reEnrollment) classificationId = offer.IDCLASSIFICACAO;
      else classificationId = course.IDCLASSIFICACAO;

      if (this.edit) qualificationId = this.preRegistration.IDHABILITACAOFILIAL;
      else if (reEnrollment) qualificationId = course.IDHABILITACAOFILIAL;
      else qualificationId = offer.IDHABILITACAOFILIAL;

      this.edit
        ? (subjectId = this.subjectId)
        : (subjectId = classData.IDTURMADISC);
      new FinancialService()
        .getScholarships(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          this.installmentSelected.numberOfInstallments
        )
        .then(({ data }) => {
          const scholarchipOptionsAux = Array.isArray(data) ? data : [data];

          const filteredScholarships = scholarchipOptionsAux.filter(
            (scholarship) => scholarship.TIPOBOLSA != "P"
          );

          const filteredScholarshipsExternal = scholarchipOptionsAux.filter(
            (scholarship) => scholarship.TIPOBOLSA == "P"
          );

          if (filteredScholarships.length > 0) {
            this.scholarchipOptions = filteredScholarships.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercent: 0,
                isDiscountPercentOfflimits: false,
                percentAllowed: false,
              })
            );
          }

          if (filteredScholarshipsExternal.length > 0) {
            this.scholarchipOptionsExternal = filteredScholarshipsExternal.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercentExternal: 0,
                isDiscountPercentOfflimits: false,
                percentAllowed: false,
              })
            );
          }
        });

      new FinancialService()
        .getScholarshipsCritical(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          this.installmentSelected.numberOfInstallments
        )
        .then(({ data }) => {
          const scholarchipOptionsAux = Array.isArray(data) ? data : [data];
          if (scholarchipOptionsAux[0] != "") {
            this.scholarchipOptionsCritical = scholarchipOptionsAux.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercentCritical: 0,
                isDiscountPercentOfflimits: false,
                percentAllowed: false,
              })
            );
          }
        });

      new FinancialService()
        .getScholarshipsException(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId,
          this.installmentSelected.numberOfInstallments
        )
        .then(({ data }) => {
          const scholarchipOptionsAux = Array.isArray(data) ? data : [data];
          if (scholarchipOptionsAux[0] != "") {
            this.scholarchipOptionsException = scholarchipOptionsAux.map(
              (scholarchip) => ({
                ...scholarchip,
                scholarshipPercent: 0,
                isDiscountPercentOfflimits: false,
                percentAllowed: false,
              })
            );
          }
        });
    },

    updateScholarShips(installment) {
      this.getScholarshipByAttendance();
      this.getScholarShip();
      this.updateSecondDueDateOptions(installment);
      //atualiza tbm se permite alterar prazo para primeira parcela
    },

    checkScholarshipValue() {
      this.scholarshipSelected.isDiscountPercentOfflimits = false;
      this.scholarshipSelected.percentAllowed = false;
      if (
        this.scholarshipSelected.scholarshipPercent !== 0 ||
        this.scholarshipSelected.scholarshipPercent !== ""
      ) {
        if (parseFloat(this.scholarshipSelected.scholarshipPercent) < 0) {
          this.scholarshipSelected.scholarshipPercent = 0;
        } else if (
          parseFloat(this.scholarshipSelected.scholarshipPercent) >
          parseFloat(this.scholarshipSelected.PERCMAX)
        ) {
          this.scholarshipSelected.isDiscountPercentOfflimits = true;
          this.scholarshipSelected.scholarshipPercent = parseFloat(
            this.scholarshipSelected.PERCMAX
          );
        } else {
          this.scholarshipSelected.percentAllowed = true;
          /*if (this.scholarshipAttData){
            const val = parseFloat(this.scholarshipAttData.PERCENTUAL) + parseFloat(this.scholarshipSelected.scholarshipPercent);
            if  (val > 100)
              this.scholarshipAttData.PERCENTUAL = 100 - (val - 100)
          }*/
        }
      } else {
        this.scholarshipSelected.scholarshipPercent = 0;
      }
    },

    checkScholarshipExternalValue() {
      this.scholarshipSelectedExternal.isDiscountPercentOfflimits = false;
      this.scholarshipSelectedExternal.percentAllowed = false;

      if (
        this.scholarshipSelectedExternal.scholarshipPercentExternal !== 0 ||
        this.scholarshipSelectedExternal.scholarshipPercentExternal !== ""
      ) {
        if (
          parseFloat(
            this.scholarshipSelectedExternal.scholarshipPercentExternal
          ) < 0
        ) {
          this.scholarshipSelectedExternal.scholarshipPercentExternal = 0;
        } else if (
          parseFloat(
            this.scholarshipSelectedExternal.scholarshipPercentExternal
          ) > parseFloat(this.scholarshipSelectedExternal.PERCMAX)
        ) {
          this.scholarshipSelectedExternal.isDiscountPercentOfflimits = true;
          this.scholarshipSelectedExternal.scholarshipPercentExternal =
            parseFloat(this.scholarshipSelectedExternal.PERCMAX);
        } else {
          this.scholarshipSelectedExternal.percentAllowed = true;
        }
      } else {
        this.scholarshipSelectedExternal.scholarshipPercentExternal = 0;
      }
    },

    checkScholarshipCriticalValue() {
      this.scholarshipSelectedCriticalClass.isDiscountPercentOfflimits = false;
      this.scholarshipSelectedCriticalClass.percentAllowed = false;

      if (
        this.scholarshipSelectedCriticalClass.scholarshipPercentCritical !==
          0 ||
        this.scholarshipSelectedCriticalClass.scholarshipPercentCritical !== ""
      ) {
        if (
          parseFloat(
            this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
          ) < 0
        ) {
          this.scholarshipSelectedCriticalClass.scholarshipPercentCritical = 0;
        } else if (
          parseFloat(
            this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
          ) >
          parseFloat(
            this.scholarshipSelectedCriticalClass.PERCBOLSATURMACRITICA
          )
        ) {
          this.scholarshipSelectedCriticalClass.isDiscountPercentOfflimits = true;
          this.scholarshipSelectedCriticalClass.scholarshipPercentCritical =
            parseFloat(
              this.scholarshipSelectedCriticalClass.PERCBOLSATURMACRITICA
            );
        } else {
          this.scholarshipSelectedCriticalClass.percentAllowed = true;
        }
      } else {
        this.scholarshipSelectedCriticalClass.scholarshipPercentCritical = 0;
      }
    },

    clearScholarShip() {
      this.scholarshipSelected = null;
      this.scholarshipSelectedExternal = null;
      this.scholarshipSelectedCriticalClass = null;
      this.scholarshipSelectedException = null;
    },

    goFoward() {
      let go = true;
      if (this.installmentSelected && this.paymentSelected) {
        if (this.installmentSelected.dueDate == "") {
          this.$vs.notify({
            fixed: true,
            title: "Favor selecione o vencimento da primeira parcela!",
            color: "danger",
            icon: "close",
          });
          go = false;
        }

        if (this.scholarshipSelected) {
          if (
            parseFloat(this.scholarshipSelected.scholarshipPercent) >
            parseFloat(this.scholarshipSelected.PERCMAX)
          ) {
            this.$vs.notify({
              fixed: true,
              title:
                "Percentual de bolsa acima do limite, favor ajuste o percentual!",
              color: "danger",
              icon: "close",
            });
            go = false;
          }

          if (
            this.scholarshipSelected.scholarshipPercent == "" &&
            this.scholarshipSelectedCriticalClass.scholarshipPercentCritical ==
              ""
          )
            this.clearScholarShip();
          if (
            this.scholarshipSelected.scholarshipPercent == "0" &&
            !this.scholarshipSelectedException &&
            this.scholarshipSelectedCriticalClass.scholarshipPercentCritical ==
              "0"
          )
            this.clearScholarShip();
          if (this.scholarshipAttData && this.scholarshipSelected && go) {
            if (
              parseFloat(this.scholarshipSelected.scholarshipPercent) >
              parseFloat(this.scholarshipAttData.PERCENTUAL)
            ) {
              this.scholarshipAttData = null;
            } else if (
              parseFloat(this.scholarshipSelected.scholarshipPercent) +
                parseFloat(this.scholarshipAttData.PERCENTUAL) >
              parseFloat(this.scholarshipAttData.PERCENTUAL)
            ) {
              this.scholarshipAttData.PERCENTUAL =
                parseFloat(this.scholarshipAttData.PERCENTUAL) -
                parseFloat(this.scholarshipSelected.scholarshipPercent);
            }
          }
          if (
            this.scholarshipSelectedExternal &&
            this.scholarshipSelected &&
            go
          ) {
            if (
              parseFloat(
                this.scholarshipSelectedExternal.scholarshipPercentExternal
              ) +
                parseFloat(this.scholarshipSelected.scholarshipPercent) >
              50
            ) {
              this.scholarshipSelected.scholarshipPercent =
                parseFloat(this.scholarshipSelected.scholarshipPercent) -
                (parseFloat(
                  this.scholarshipSelectedExternal.scholarshipPercentExternal
                ) +
                  parseFloat(this.scholarshipSelected.scholarshipPercent) -
                  50);
            }
          }
          if (
            this.scholarshipSelectedCriticalClass &&
            this.scholarshipSelected &&
            go
          ) {
            if (
              parseFloat(
                this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
              ) +
                parseFloat(this.scholarshipSelected.scholarshipPercent) >
              50
            ) {
              this.scholarshipSelected.scholarshipPercent =
                parseFloat(this.scholarshipSelected.scholarshipPercent) -
                (parseFloat(
                  this.scholarshipSelectedCriticalClass
                    .scholarshipPercentCritical
                ) +
                  parseFloat(this.scholarshipSelected.scholarshipPercent) -
                  50);
            }
          }
        }
        if (go) {
          updateDiscussion(
            "Selecionou Financeiro: Matrícula em " +
              this.installmentSelected.numberOfInstallments +
              "x, com 1º vencimento em " +
              this.installmentSelected.dueDate +
              (this.scholarshipSelectedCriticalClass &&
              this.scholarshipSelectedCriticalClass
                .scholarshipPercentCritical &&
              this.scholarshipSelectedCriticalClass
                .scholarshipPercentCritical != null &&
              this.scholarshipSelectedCriticalClass
                .scholarshipPercentCritical != "0"
                ? " e " +
                  this.scholarshipSelectedCriticalClass
                    .scholarshipPercentCritical +
                  "% de " +
                  this.scholarshipSelectedCriticalClass.DESCRICAO
                : "") +
              (this.scholarshipSelectedExternal &&
              this.scholarshipSelectedExternal.scholarshipPercentExternal &&
              this.scholarshipSelectedExternal.scholarshipPercentExternal !=
                null &&
              this.scholarshipSelectedExternal.scholarshipPercentExternal != "0"
                ? " e " +
                  this.scholarshipSelectedExternal.scholarshipPercentExternal +
                  "% de " +
                  this.scholarshipSelectedExternal.DESCRICAO
                : "") +
              (this.scholarshipSelected &&
              this.scholarshipSelected.scholarshipPercent &&
              this.scholarshipSelected.scholarshipPercent != null &&
              this.scholarshipSelected.scholarshipPercent != "0"
                ? this.scholarshipSelectedCriticalClass &&
                  this.scholarshipSelectedCriticalClass
                    .scholarshipPercentCritical &&
                  this.scholarshipSelectedCriticalClass
                    .scholarshipPercentCritical != null &&
                  this.scholarshipSelectedCriticalClass
                    .scholarshipPercentCritical != "0"
                  ? ", além de " +
                    this.scholarshipSelected.scholarshipPercent +
                    "% de " +
                    this.scholarshipSelected.DESCRICAO +
                    ","
                  : this.scholarshipSelectedExternal &&
                    this.scholarshipSelectedExternal
                      .scholarshipPercentExternal &&
                    this.scholarshipSelectedExternal
                      .scholarshipPercentExternal != null &&
                    this.scholarshipSelectedExternal
                      .scholarshipPercentExternal != "0"
                  ? ", além de " +
                    this.scholarshipSelected.scholarshipPercent +
                    "% de " +
                    this.scholarshipSelected.DESCRICAO +
                    ","
                  : " e " +
                    this.scholarshipSelected.scholarshipPercent +
                    "% de " +
                    this.scholarshipSelected.DESCRICAO +
                    ","
                : ",") +
              " no " +
              this.paymentSelected.DESCRICAO,
            {
              payment: this.paymentSelected.DESCRICAO,
            }
          ).finally(() => {
            updateStepsInformation({
              payment: this.paymentSelected,
              installment: this.installmentSelected,
              scholarship: this.scholarshipSelected,
              scholarshipExternal: this.scholarshipSelectedExternal,
              scholarshipCritical: this.scholarshipSelectedCriticalClass,
              scholarshipException: this.scholarshipSelectedException,
              scholarshipByAttendance: this.scholarshipAttData,
            });
            const { course, reEnrollment } = getStepsInformation();
            if (this.edit) this.$router.push("/reviewInformation");
            else if (course)
              if (course.MODALIDADE != "Graduação" && reEnrollment)
                this.$router.push("/remFinancialResponsible");
              else if (course.MODALIDADE != "Graduação")
                this.$router.push("/financialResponsible");
              else this.$router.push("/admissionMode");
          });
        }
      } else {
        this.$vs.notify({
          fixed: true,
          title: "É preciso selecionar Parcelamento e Forma de pagamento!",
          color: "danger",
          icon: "close",
        });
      }
    },

    scapePayment() {
      /*const { preRegistration } = getStepsInformation();
      if (preRegistration.MODALIDADECURSO == '3') this.$router.push("/admissionMode");
      else this.$router.push("/reviewInformation");*/

      this.$router.push("/reviewInformation");
    },

    getInstallmentValue(payment) {
      const { installmentSelected, totalCourseValue } = this;
      const installments =
        payment.AVISTA === "S" ? 1 : installmentSelected.numberOfInstallments;
      return installmentSelected
        ? (totalCourseValue / installments).toFixed(2)
        : 0;
    },

    getInstallmentLiquidValue(payment) {
      const installmentValue = this.getInstallmentValue(payment);
      if (
        this.installmentSelected &&
        (this.scholarshipSelected ||
          this.scholarshipSelectedCriticalClass ||
          this.scholarshipSelectedExternal)
      ) {
        return (
          (installmentValue *
            (100 -
              (this.scholarshipSelected &&
              this.scholarshipSelected.scholarshipPercent
                ? parseFloat(this.scholarshipSelected.scholarshipPercent)
                : 0) -
              (this.scholarshipSelectedExternal &&
              this.scholarshipSelectedExternal.scholarshipPercentExternal
                ? parseFloat(
                    this.scholarshipSelectedExternal.scholarshipPercentExternal
                  )
                : 0) -
              (this.scholarshipSelectedException
                ? parseFloat(this.scholarshipSelectedException.PMAX)
                : 0) -
              (this.scholarshipSelectedCriticalClass &&
              this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
                ? parseFloat(
                    this.scholarshipSelectedCriticalClass
                      .scholarshipPercentCritical
                  )
                : 0))) /
          100
        ).toFixed(2);
      }
      return installmentValue;
    },

    getSalePoints(payment) {
      let valorLiquido = this.totalCourseValue;

      if (this.installmentSelected && this.scholarshipSelected) {
        if (this.scholarshipSelected.scholarshipPercent != "") {
          valorLiquido =
            valorLiquido -
            (valorLiquido * this.scholarshipSelected.scholarshipPercent) / 100;
        }
        if (this.scholarshipAttData) {
          valorLiquido =
            valorLiquido -
            ((this.getInstallmentLiquidValue(payment) *
              this.scholarshipAttData.PERCENTUAL) /
              100) *
              (this.scholarshipAttData.PARCELAFIM -
                this.scholarshipAttData.PARCELAINI);
        }
      }
      return valorLiquido * this.offer.FATORMULTIPLICADOR;
    },

    getScholarshipValue(payment) {
      const installmentValue = this.getInstallmentValue(payment);
      return (
        installmentValue *
        (((this.scholarshipSelected &&
        this.scholarshipSelected.scholarshipPercent
          ? parseFloat(this.scholarshipSelected.scholarshipPercent)
          : 0) +
          (this.scholarshipSelectedExternal &&
          this.scholarshipSelectedExternal.scholarshipPercentExternal
            ? parseFloat(
                this.scholarshipSelectedExternal.scholarshipPercentExternal
              )
            : 0) +
          (this.scholarshipSelectedException
            ? parseFloat(this.scholarshipSelectedException.PMAX)
            : 0) +
          (this.scholarshipSelectedCriticalClass &&
          this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
            ? parseFloat(
                this.scholarshipSelectedCriticalClass.scholarshipPercentCritical
              )
            : 0)) /
          100)
      ).toFixed(2);
    },
    getPaymentDiscount(payment) {
      const installmentValue = this.getInstallmentLiquidValue(payment);
      return installmentValue && +payment.PERCDESC
        ? (installmentValue * (+payment.PERCDESC / 100)).toFixed(2)
        : 0;
    },
    getTotalValue(payment) {
      const { getScholarshipValue, getPaymentDiscount, getInstallmentValue } =
        this;
      const installmentValue = getInstallmentValue(payment);
      return (
        installmentValue -
        getScholarshipValue(payment) -
        getPaymentDiscount(payment)
      ).toFixed(2);
    },
  },

  computed: {
    numberOfInstallmentsPossible() {
      if (!this.installmentSelected) return [0];
      return Array.from(
        Array(+this.installmentSelected.NUMERODEPARCELAS).keys()
      );
    },
  },
};
</script>

<style>
#payment-page .no-flex div.vs-col {
  flex: 0 !important;
}
#payment-page .text-center {
  text-align: center;
}
#payment-page .choosable-card,
#payment-page .exception-card {
  cursor: pointer;
}

#payment-page .exception-card {
  box-shadow: 0 0 5px 3px rgba(255, 0, 0, 0.7);
}

#payment-page .choosable-card:hover,
#payment-page .exception-card:hover {
  cursor: pointer;
  box-shadow: 0 0 5px 3px rgba(var(--vs-primary), 0.7);
}

#payment-page .choosable-card.selected,
#payment-page .exception-card.selected {
  box-shadow: 0 0 0 2.75px rgb(var(--vs-primary)) !important;
  cursor: default;
}

#payment-page .choosable-card.disabled,
#payment-page .exception-card.disabled,
#payment-page
  .choosable-card.disabled:hover
  #payment-page
  .exception-card.disabled:hover {
  cursor: default;
  color: #888;
  box-shadow: none;
}

#payment-page .select-due-date {
  display: flex;
  justify-content: space-between;
}

#payment-page .select-due-date select {
  display: flex;
  justify-content: space-between;
}

#payment-page .spacing-children > p,
#payment-page .spacing-children > div {
  margin: 12px 0;
}

#payment-page .no-material-font i {
  font-family: Verdana, sans-serif;
}
</style>
